export const userStates = {
  isProcessing: "Checking"
};

const LEGAL_DOCUMENT_ROLES = {
  admin: "ADMIN",
  user: "USER",
  legal: "LEGAL",
  finance: "BUSINESS_FINANCE",
  accounts: "BUSINESS_ACCOUNTS"
};
